/* eslint-disable react/prop-types */
import React from "react";
import Loader from "../../shared/loader";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import styles from "./styles.css";
import Accordion from "../../shared/accordion";
import ArrowIcon from "../../shared/arrow";
import { FILTER_ENTITIES } from "../../../utils/filters-v2/constants";
import { NUMBER } from "../../../constants/app-constants";

// eslint-disable-next-line complexity
const AccordionItem = React.memo(({
    item,
    index,
    Component,
    header,
    type,
    icon,
    filterCount,
    allFilters,
    selectedFilters,
    onOptionSelection,
    config,
    getListingUrl,
    getComponentProps,
    triggerEvent,
    getHeaderText,
    props
}) => {
    return (
        <Accordion.Content>
            <Accordion.Heading>
                <div styleName={"styles.makeModelHeaderWrap"} onClick={async () => {
                    props.onClick({ index });
                    await yieldToMain();
                    triggerEvent(item, props.currentVisibleStates[index]);
                }}>
                    <div styleName={"styles.makeModelCountWrap"}>
                        {type === FILTER_ENTITIES.GREAT_DEALS && icon && (
                            <img src={icon} alt={`${type}-icon`} />
                        )}
                        <p styleName={"styles.makeModelHeading"}>{getHeaderText(header, type)}</p>
                        {filterCount && <p styleName={"styles.makeModelCount"}>{filterCount}</p>}
                    </div>
                    {props.loading && props.loadingIndex === index ? (
                        <Loader />
                    ) : (
                        <ArrowIcon rotateBy={props.currentVisibleStates[index] ? NUMBER.NINETY : -NUMBER.NINETY} />
                    )}
                </div>
            </Accordion.Heading>
            <Accordion.Body>
                {!props.currentVisibleStates[index] && !props.loading && (
                    <Component
                        {...getComponentProps(allFilters, type)}
                        selectedFilters={selectedFilters}
                        onOptionSelection={onOptionSelection}
                        appliedFilters={selectedFilters}
                        filter={allFilters[type]}
                        config={config}
                        allFilters={allFilters}
                        getListingUrl={getListingUrl}
                        {...props}
                    />
                )}
                {!props.currentVisibleStates[index] && props.loading && props.loadingIndex === index && (
                    <div>Loading...</div>
                )}
            </Accordion.Body>
        </Accordion.Content>
    );
});
export default AccordionItem;

